export default "__VITE_ASSET__Cxsevk8m__"